export default "__VITE_ASSET__12295594__"